import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { UploadMCNumber, ValidateMCNumber, FetchDriver } from 'src/constants/actionTypes'
import { captureSentryError } from 'src/utils/sentry'

interface ValidateMCNumberRequest {
  mcNumber: string
  stepId: string
}

interface UploadMCNumberRequest {
  mcNumber: string
  stepId: string
  lastSubmittedAt?: string
}

interface ValidateMCNumberResponsePayload {
  isValid: boolean
}

function* onValidateMCNumber(action: AsyncAction<ValidateMCNumberRequest>) {
  const { mcNumber, stepId } = action.payload

  try {
    const { payload }: { payload: ValidateMCNumberResponsePayload } = yield call(
      callClientSecureApi,
      Endpoints.ValidateMCNumber,
      {
        method: 'POST',
        body: {
          mcNumber,
          stepId,
        },
        apiService: ApiService.Paraworks,
      },
    )

    yield put(ValidateMCNumber.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.mcNumber.onValidateMCNumber] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to validate MC number'

    yield put(ValidateMCNumber.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

function* onUploadMCNumber(action: AsyncAction<UploadMCNumberRequest>) {
  const { mcNumber, stepId, lastSubmittedAt } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.UploadMCNumber, {
      method: 'POST',
      body: { mcNumber, stepId, lastSubmittedAt },
      apiService: ApiService.Paraworks,
    })

    yield put(UploadMCNumber.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.mcNumber.onUploadMCNumber] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to upload MC number'

    yield put(UploadMCNumber.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* mcNumberSaga() {
  yield takeLatest(ValidateMCNumber.type.REQUEST, onValidateMCNumber)
  yield takeLatest(UploadMCNumber.type.REQUEST, onUploadMCNumber)
}
